import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "alert alert-primary d-flex align-items-center p-5 mb-10 pulse pulse-primary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19 15V18C19 18.6 18.6 19 18 19H6C5.4 19 5 18.6 5 18V15C6.1 15 7 14.1 7 13V10C7 7.6 8.7 5.6 11 5.1V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V5.1C15.3 5.6 17 7.6 17 10V13C17 14.1 17.9 15 19 15ZM11 10C11 9.4 11.4 9 12 9C12.6 9 13 8.6 13 8C13 7.4 12.6 7 12 7C10.3 7 9 8.3 9 10C9 10.6 9.4 11 10 11C10.6 11 11 10.6 11 10Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "pulse-ring",
  style: {"margin-left":"-3px"}
}, null, -1)
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "mb-1 text-primary" }
const _hoisted_6 = { class: "card mb-5 mb-xl-10" }
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body p-9" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = {
  key: 0,
  class: "col text-end"
}
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-4 fv-row" }
const _hoisted_20 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_21 = { class: "pt-5" }
const _hoisted_22 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "col-lg-8 fv-row" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_41 = { class: "col-lg-8 fv-row" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "pt-5" }
const _hoisted_45 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-5" }, null, -1)
const _hoisted_47 = { class: "row mb-6" }
const _hoisted_48 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_49 = { class: "col-lg-8 fv-row" }
const _hoisted_50 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_51 = { class: "row mb-6" }
const _hoisted_52 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "col-lg-8 fv-row" }
const _hoisted_54 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_61 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_62 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_63 = { class: "col-lg-8 fv-row" }
const _hoisted_64 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_65 = { class: "row mb-6" }
const _hoisted_66 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_67 = { class: "col-lg-8 fv-row" }
const _hoisted_68 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_69 = { class: "row mb-6" }
const _hoisted_70 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_71 = { class: "col-lg-8 fv-row" }
const _hoisted_72 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_73 = { class: "card mb-5 mb-xl-10" }
const _hoisted_74 = { class: "card-header border-0" }
const _hoisted_75 = { class: "card-title m-0" }
const _hoisted_76 = { class: "fw-bolder m-0" }
const _hoisted_77 = { class: "collapse show" }
const _hoisted_78 = { class: "card-body border-top p-9" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_81 = { class: "col-lg-8 fv-row" }
const _hoisted_82 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_83 = {
  key: 0,
  class: "row"
}
const _hoisted_84 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_85 = { class: "col-lg-8 fv-row" }
const _hoisted_86 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_89 = { class: "col-lg-8 fv-row" }
const _hoisted_90 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_91 = {
  key: 1,
  class: "row"
}
const _hoisted_92 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "col-lg-8 fv-row" }
const _hoisted_94 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_97 = { class: "col-lg-8 fv-row" }
const _hoisted_98 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_100 = {
  key: 2,
  class: "pb-5"
}
const _hoisted_101 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_102 = {
  key: 3,
  class: "row"
}
const _hoisted_103 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_104 = { class: "col-lg-8 fv-row" }
const _hoisted_105 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_106 = {
  key: 4,
  class: "row"
}
const _hoisted_107 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_108 = { class: "col-lg-8 fv-row" }
const _hoisted_109 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_110 = {
  key: 5,
  class: "row"
}
const _hoisted_111 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_112 = { class: "col-lg-8 fv-row" }
const _hoisted_113 = { class: "col-form-label fw-normal fs-6" }
const _hoisted_114 = {
  class: "col-lg-12 fw-normal fs-6 mb-4",
  style: {"white-space":"break-spaces"}
}
const _hoisted_115 = { class: "col-lg-8 fv-row" }
const _hoisted_116 = { class: "row" }
const _hoisted_117 = { class: "col fv-row fv-plugins-icon-container" }
const _hoisted_118 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EstadoTag = _resolveComponent("EstadoTag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Page = _resolveComponent("Page")!
  const _component_SendEmailModal = _resolveComponent("SendEmailModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Page, { showBack: "" }, {
      actions: _withCtx(() => [
        _createVNode(_component_el_dropdown, { class: "mx-3" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  onClick: _ctx.openServicioColectivoPicker,
                  loading: _ctx.crearServicioProgramado,
                  disabled: _ctx.lugarPrestacion !== 'ESPACIO'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("dialogs.reasignarAServicioColectivo.button")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "loading", "disabled"]),
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_send_email",
                  onClick: _ctx.prepareSendEmail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.enviarCorreo")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "default" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_down)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.guardar,
          loading: _ctx.crearServicioProgramado
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.guardar")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        (!_ctx.familiaAprobada)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `/solicitudes/familias/${_ctx.solicitudFamiliaId}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("formularios.servicioDetalle.alerta.familiaPendiente.titulo")), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(
              "formularios.servicioDetalle.alerta.familiaPendiente.descripcion"
            )), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: 
          _ctx.$t('formularios.servicioColectivoDetalle.datosSolicitanteGroup')
        
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("listados.servicioDetalle.estado.label")), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_el_select, {
                                name: "estado",
                                modelValue: _ctx.estado,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.estado) = $event)),
                                class: "w-100"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estados, (estado, i) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      value: estado.value,
                                      label: estado.label,
                                      disabled: 
                            !_ctx.familiaAprobada &&
                            estado.value === _ctx.FormularioEstado.incorporado
                          ,
                                      key: i
                                    }, null, 8, ["value", "label", "disabled"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_ErrorMessage, { name: "lugarPrestacion" })
                                ])
                              ])
                            ]),
                            (_ctx.estadoOrginal)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createVNode(_component_EstadoTag, { estado: _ctx.estadoOrginal }, null, 8, ["estado"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("formularios.servicioDetalle.fecha.label")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.formatDate(_ctx.createdOn)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$t("formularios.servicioDetalle.datosMenor")), 1)
                      ]),
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_el_select, {
                            name: "tratamiento",
                            class: "w-100",
                            modelValue: _ctx.tratamiento,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tratamiento) = $event)),
                            disabled: !_ctx.editable
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: tratamiento.text,
                                  value: tratamiento.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_ErrorMessage, { name: "tratamiento" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("formularios.servicioDetalle.menor.nombreMenor")), 1),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "nombre",
                                placeholder: " ",
                                modelValue: _ctx.nombre,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nombre) = $event)),
                                disabled: !_ctx.editable
                              }, null, 8, ["modelValue", "disabled"]),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_component_ErrorMessage, { name: "nombre" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "apellidos",
                                placeholder: " ",
                                modelValue: _ctx.apellidos,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.apellidos) = $event)),
                                disabled: !_ctx.editable
                              }, null, 8, ["modelValue", "disabled"]),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createVNode(_component_ErrorMessage, { name: "apellidos" })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.fechaNacimiento.label")), 1),
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_el_date_picker, {
                            format: "DD/MM/YYYY",
                            name: "fechaNacimiento",
                            modelValue: _ctx.fechaNacimiento,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fechaNacimiento) = $event)),
                            disabled: !_ctx.editable,
                            type: "date",
                            class: "w-100"
                          }, null, 8, ["modelValue", "disabled"]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_ErrorMessage, { name: "fechaNacimiento" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("h4", _hoisted_45, _toDisplayString(_ctx.$t("formularios.servicioDetalle.infoServicioColectivo")), 1)
                      ]),
                      _hoisted_46,
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("formularios.servicioDetalle.nombreServicio.label")), 1),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("label", _hoisted_50, [
                            _createVNode(_component_router_link, { to: _ctx.servicioColectivoUrl }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.nombreServicio), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("listados.servicioDetalle.lugarPrestacion.label")), 1),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.lugaresPrestacion.find((e) => e.id == _ctx.lugarPrestacion)
                        ?.nombre), 1),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(_component_ErrorMessage, { name: "lugarPrestacion" })
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.lugarPrestacion == 'ESPACIO')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("listados.servicioDetalle.lugarEspacioColectivo.label")), 1),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.lugaresEspaciosColectivos.find(
                        (e) => e.id == _ctx.lugarEspacioColectivo
                      )?.nombre), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.lugarEspacioColectivo == 'OTROS')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t("listados.servicioDetalle.otrosEspacioColectivo.label")), 1),
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.otrosEspacioColectivo), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t("formularios.servicioDetalle.direccion.label")), 1),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.direccion), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t("formularios.servicioDetalle.ubicacion.label")), 1),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.comarcas.find((e) => e.id == _ctx.comarcaId)?.nombreCompuesto), 1)
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.servicioDetalle.datosFamilia')
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("h3", _hoisted_76, _toDisplayString(_ctx.$t("formularios.servicioDetalle.datosFamilia")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.familiaTratamiento.text), 1)
                        ])
                      ]),
                      (_ctx.familia && _ctx.familia.nombre && _ctx.familia.apellidos)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
                            _createElementVNode("div", _hoisted_85, [
                              _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.familia.nombre + " " + _ctx.familia.apellidos), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.$t("formularios.familiaDetalle.dni.label")), 1),
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.familiaDNI), 1)
                        ])
                      ]),
                      (_ctx.familia && _ctx.familia.email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t("formularios.familiaDetalle.email.label")), 1),
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.familia.email), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.$t("formularios.familiaDetalle.telefono.label")), 1),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.familiaTelefono), 1)
                        ])
                      ]),
                      _hoisted_99,
                      (_ctx.familia && _ctx.familia.direccion)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                            _createElementVNode("h4", _hoisted_101, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccionGroup")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.familia && _ctx.familia.direccion)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                            _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccion.label")), 1),
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.familia.direccion), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.familia && _ctx.familia.localidad)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                            _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t("formularios.familiaDetalle.localidad.label")), 1),
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.familia.localidad), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.familia && _ctx.familia.provincia)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                            _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.$t("formularios.familiaDetalle.provincia.label")), 1),
                            _createElementVNode("div", _hoisted_112, [
                              _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.familia.provincia), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.cargaDetalle]
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_dialog, {
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: _ctx.$t('dialogs.reasignarAServicioColectivo.title')
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_118, [
              _createVNode(_component_el_button, { onClick: _ctx.closeServicioColectivoPicker }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("dialogs.reasignarAServicioColectivo.cancelButton")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.asignarServicioColectivo,
                disabled: !_ctx.dialogSelected
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("dialogs.reasignarAServicioColectivo.okButton")), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.$t("dialogs.reasignarAServicioColectivo.texto")), 1),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("div", _hoisted_117, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.dialogSelected,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogSelected) = $event)),
                    class: "w-100",
                    placeholder: 
                _ctx.$t('dialogs.reasignarAServicioColectivo.placeholder')
              ,
                    "no-data-text": 
                _ctx.$t('dialogs.reasignarAServicioColectivo.sinServiciosColectivos')
              ,
                    "popper-class": "w-auto"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogData, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.nombre,
                          value: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.nombre), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder", "no-data-text"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "title"])), [
          [_directive_loading, _ctx.dialogLoading]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_SendEmailModal, {
      context: _ctx.sendEmailContext,
      onSendEmail: _ctx.onSendEmail
    }, null, 8, ["context", "onSendEmail"])
  ], 64))
}